// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"ef64a898","653":"d7dc788d","682":"2e4b15fb","728":"4e509b1e","787":"9a26bd31"}[chunkId] + ".chunk.js";
};